<mat-toolbar class="flex justify-between items-center">
  <div class="flex">
    <span class="prefix-wrapper"
      ><ng-content select=".prefix"></ng-content
    ></span>
  </div>
  <div>
    <ng-content select=".actions"></ng-content>
    <button color="accent" mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon>account_circle</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      @if (currentWorkspace?.organizationId) {
      <button mat-menu-item (click)="navigateToMyTraining()">
        My Training
      </button>
      }
      <button mat-menu-item (click)="logoutClick()">Logout</button>
      @if (workspaces.length > 1) {
      <button mat-menu-item (click)="changeWorkspace()">
        Change Workspace
      </button>
      }
    </mat-menu>
  </div>
</mat-toolbar>
